import React from 'react'
import PropTypes from 'prop-types'

import FormHeader from '../FormHeader/FormHeader'
import Details from '../Steps/Details'
import DateAndTime from '../Steps/DateAndTime'
import Summary from '../Steps/Summary'
import MediaUploadEditMode from '../Steps/MediaUploadEditMode'
import SummaryBuilding from '../Steps/SummaryBuilding'

const EditEvent = ({ config, eventType, handleClose }) => {
  const SummaryComponent = eventType === 'buildingEvent' ? SummaryBuilding : Summary
  return (
    <React.Fragment>
      <FormHeader editMode eventType={eventType} handleClose={handleClose} />
      <Details editMode config={config.details} />
      <hr />
      <MediaUploadEditMode editMode config={config.mediaUpload} />
      <hr />
      <DateAndTime editMode config={config.dateAndTime} />
      <hr />
      <SummaryComponent
        config={{ ...config.summary, footer: config.footer }}
        onBack={handleClose}
      />
    </React.Fragment>
  )
}

EditEvent.propTypes = {
  confirm: PropTypes.object,
  eventType: PropTypes.string,
  handleClose: PropTypes.func,
  config: PropTypes.object,
}

export default EditEvent
